
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/ios',
              siteOrigin: 'https://docs.mapbox.com',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/ios/',
            getPage: () => import(
              /* webpackChunkName: "ios" */
              '/work/ios-sdk/_site_tmp/_ios.js'
            ),
            
            
          },{
            path: '/ios/api/',
            getPage: () => import(
              /* webpackChunkName: "ios-api" */
              '/work/ios-sdk/_site_tmp/_ios_api.js'
            ),
            
            
          },{
            path: '/ios/beta/maps/',
            getPage: () => import(
              /* webpackChunkName: "ios-beta-maps" */
              '/work/ios-sdk/_site_tmp/_ios_beta_maps.js'
            ),
            
            
          },{
            path: '/ios/beta/maps/api-reference/',
            getPage: () => import(
              /* webpackChunkName: "ios-beta-maps-api-reference" */
              '/work/ios-sdk/_site_tmp/_ios_beta_maps_api-reference.js'
            ),
            
            
          },{
            path: '/ios/beta/maps/examples/',
            getPage: () => import(
              /* webpackChunkName: "ios-beta-maps-examples" */
              '/work/ios-sdk/_site_tmp/_ios_beta_maps_examples.js'
            ),
            
            
          },{
            path: '/ios/beta/maps/examples/user-location/',
            getPage: () => import(
              /* webpackChunkName: "ios-beta-maps-examples-user-location" */
              '/work/ios-sdk/_site_tmp/_ios_beta_maps_examples_user-location.js'
            ),
            
            
          },{
            path: '/ios/beta/maps/guides/',
            getPage: () => import(
              /* webpackChunkName: "ios-beta-maps-guides" */
              '/work/ios-sdk/_site_tmp/_ios_beta_maps_guides.js'
            ),
            
            
          },{
            path: '/ios/beta/navigation/',
            getPage: () => import(
              /* webpackChunkName: "ios-beta-navigation" */
              '/work/ios-sdk/_site_tmp/_ios_beta_navigation.js'
            ),
            
            
          },{
            path: '/ios/beta/navigation/api-reference/',
            getPage: () => import(
              /* webpackChunkName: "ios-beta-navigation-api-reference" */
              '/work/ios-sdk/_site_tmp/_ios_beta_navigation_api-reference.js'
            ),
            
            
          },{
            path: '/ios/beta/navigation/examples/',
            getPage: () => import(
              /* webpackChunkName: "ios-beta-navigation-examples" */
              '/work/ios-sdk/_site_tmp/_ios_beta_navigation_examples.js'
            ),
            
            
          },{
            path: '/ios/beta/navigation/guides/',
            getPage: () => import(
              /* webpackChunkName: "ios-beta-navigation-guides" */
              '/work/ios-sdk/_site_tmp/_ios_beta_navigation_guides.js'
            ),
            
            
          },{
            path: '/ios/directions/',
            getPage: () => import(
              /* webpackChunkName: "ios-directions" */
              '/work/ios-sdk/_site_tmp/_ios_directions.js'
            ),
            
            
          },{
            path: '/ios/directions/api-reference/',
            getPage: () => import(
              /* webpackChunkName: "ios-directions-api-reference" */
              '/work/ios-sdk/_site_tmp/_ios_directions_api-reference.js'
            ),
            
            
          },{
            path: '/ios/legacy/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy" */
              '/work/ios-sdk/_site_tmp/_ios_legacy.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/api-reference/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-api-reference" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_api-reference.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/add-marker-symbol/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-add-marker-symbol" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_add-marker-symbol.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/annotation-views/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-annotation-views" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_annotation-views.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/approximate-location/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-approximate-location" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_approximate-location.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/camera-animation/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-camera-animation" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_camera-animation.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/clustering-with-images/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-clustering-with-images" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_clustering-with-images.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/clustering/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-clustering" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_clustering.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/constraining-gestures/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-constraining-gestures" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_constraining-gestures.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/custom-callout/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-custom-callout" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_custom-callout.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/custom-style/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-custom-style" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_custom-style.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/dds-circle-layer/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-dds-circle-layer" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_dds-circle-layer.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/default-callout/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-default-callout" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_default-callout.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/default-styles/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-default-styles" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_default-styles.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/draggable-views/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-draggable-views" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_draggable-views.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/fill-pattern/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-fill-pattern" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_fill-pattern.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/heatmap-example/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-heatmap-example" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_heatmap-example.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/image-source/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-image-source" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_image-source.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/inset-map/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-inset-map" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_inset-map.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/light-example/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-light-example" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_light-example.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/live-data/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-live-data" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_live-data.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/map-snapshotter/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-map-snapshotter" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_map-snapshotter.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/multiple-images/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-multiple-images" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_multiple-images.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/multiple-shapes/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-multiple-shapes" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_multiple-shapes.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/offline-pack/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-offline-pack" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_offline-pack.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/offline-storage/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-offline-storage" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_offline-storage.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/point-conversion/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-point-conversion" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_point-conversion.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/runtime-add-line/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-runtime-add-line" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_runtime-add-line.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/runtime-animate-line/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-runtime-animate-line" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_runtime-animate-line.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/runtime-multiple-annotations/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-runtime-multiple-annotations" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_runtime-multiple-annotations.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/runtime-toggle-layer/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-runtime-toggle-layer" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_runtime-toggle-layer.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/select-layer/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-select-layer" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_select-layer.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/shape-collection/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-shape-collection" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_shape-collection.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/simple-map-view/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-simple-map-view" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_simple-map-view.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/source-custom-raster/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-source-custom-raster" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_source-custom-raster.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/source-custom-vector/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-source-custom-vector" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_source-custom-vector.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/switch-styles/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-switch-styles" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_switch-styles.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/user-location-annotation/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-user-location-annotation" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_user-location-annotation.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/examples/user-tracking-mode/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-examples-user-tracking-mode" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_examples_user-tracking-mode.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/guides/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-guides" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_guides.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/guides/install/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-guides-install" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_guides_install.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/guides/interacting-with-the-map/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-guides-interacting-with-the-map" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_guides_interacting-with-the-map.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/guides/map-design-for-ios/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-guides-map-design-for-ios" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_guides_map-design-for-ios.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/guides/mapbox-studio/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-guides-mapbox-studio" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_guides_mapbox-studio.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/guides/markers-and-annotations/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-guides-markers-and-annotations" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_guides_markers-and-annotations.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/guides/offline/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-guides-offline" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_guides_offline.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/guides/pricing/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-guides-pricing" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_guides_pricing.js'
            ),
            
            
          },{
            path: '/ios/legacy/maps/guides/runtime-styling/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-maps-guides-runtime-styling" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_maps_guides_runtime-styling.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/api-reference/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-api-reference" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_api-reference.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/advanced/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples-advanced" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples_advanced.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/basic/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples-basic" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples_basic.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/building-extrusion/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples-building-extrusion" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples_building-extrusion.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/custom-banner/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples-custom-banner" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples_custom-banner.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/custom-destination-marker/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples-custom-destination-marker" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples_custom-destination-marker.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/custom-server/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples-custom-server" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples_custom-server.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/custom-voice-controller/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples-custom-voice-controller" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples_custom-voice-controller.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/embedded-navigation/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples-embedded-navigation" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples_embedded-navigation.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/route-deserialization/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples-route-deserialization" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples_route-deserialization.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/route-initialization/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples-route-initialization" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples_route-initialization.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/styled-ui-elements/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples-styled-ui-elements" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples_styled-ui-elements.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/examples/waypoint-arrival-screen/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-examples-waypoint-arrival-screen" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_examples_waypoint-arrival-screen.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/guides/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-guides" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_guides.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/guides/app-styling/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-guides-app-styling" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_guides_app-styling.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/guides/carplay/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-guides-carplay" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_guides_carplay.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/guides/free-driving/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-guides-free-driving" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_guides_free-driving.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/guides/install/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-guides-install" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_guides_install.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/guides/instructions/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-guides-instructions" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_guides_instructions.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/guides/localization-and-internationalization/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-guides-localization-and-internationalization" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_guides_localization-and-internationalization.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/guides/pricing/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-guides-pricing" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_guides_pricing.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/guides/rerouting/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-guides-rerouting" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_guides_rerouting.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/guides/route-generation/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-guides-route-generation" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_guides_route-generation.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/guides/route-progress/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-guides-route-progress" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_guides_route-progress.js'
            ),
            
            
          },{
            path: '/ios/legacy/navigation/guides/storyboards/',
            getPage: () => import(
              /* webpackChunkName: "ios-legacy-navigation-guides-storyboards" */
              '/work/ios-sdk/_site_tmp/_ios_legacy_navigation_guides_storyboards.js'
            ),
            
            
          },{
            path: '/ios/maps/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps" */
              '/work/ios-sdk/_site_tmp/_ios_maps.js'
            ),
            
            
          },{
            path: '/ios/maps/api-reference/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-api-reference" */
              '/work/ios-sdk/_site_tmp/_ios_maps_api-reference.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/animate-image-layer/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-animate-image-layer" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_animate-image-layer.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/building-extrusions/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-building-extrusions" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_building-extrusions.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/camera-animation/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-camera-animation" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_camera-animation.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/camera-animators/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-camera-animators" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_camera-animators.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/clustering-with-images/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-clustering-with-images" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_clustering-with-images.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/clustering/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-clustering" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_clustering.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/custom-style/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-custom-style" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_custom-style.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/data-driven-symbols/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-data-driven-symbols" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_data-driven-symbols.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/fly-to/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-fly-to" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_fly-to.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/line-gradient/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-line-gradient" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_line-gradient.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/live-data/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-live-data" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_live-data.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/map-snapshotter/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-map-snapshotter" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_map-snapshotter.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/multiple-shapes/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-multiple-shapes" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_multiple-shapes.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/offline-pack/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-offline-pack" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_offline-pack.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/offline-storage/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-offline-storage" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_offline-storage.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/point-annotation/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-point-annotation" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_point-annotation.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/point-conversion/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-point-conversion" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_point-conversion.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/restrict-coordinate-bounds/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-restrict-coordinate-bounds" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_restrict-coordinate-bounds.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/runtime-animate-line/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-runtime-animate-line" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_runtime-animate-line.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/shape-collection/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-shape-collection" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_shape-collection.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/show-hide-layer/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-show-hide-layer" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_show-hide-layer.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/simple-map-view/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-simple-map-view" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_simple-map-view.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/switch-styles/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-switch-styles" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_switch-styles.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/tracking-mode/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-tracking-mode" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_tracking-mode.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/view-annotation-basic/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-view-annotation-basic" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_view-annotation-basic.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/view-annotation-marker/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-view-annotation-marker" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_view-annotation-marker.js'
            ),
            
            
          },{
            path: '/ios/maps/examples/view-annotation-with-point-annotation/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-examples-view-annotation-with-point-annotation" */
              '/work/ios-sdk/_site_tmp/_ios_maps_examples_view-annotation-with-point-annotation.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/annotations/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-annotations" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_annotations.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/annotations/annotations/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-annotations-annotations" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_annotations_annotations.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/annotations/style-layers/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-annotations-style-layers" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_annotations_style-layers.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/annotations/view-annotations/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-annotations-view-annotations" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_annotations_view-annotations.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/camera-and-animation/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-camera-and-animation" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_camera-and-animation.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/camera-and-animation/animations/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-camera-and-animation-animations" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_camera-and-animation_animations.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/camera-and-animation/camera/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-camera-and-animation-camera" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_camera-and-animation_camera.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/install/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-install" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_install.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/migrate-to-v10/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-migrate-to-v10" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_migrate-to-v10.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/offline/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-offline" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_offline.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/pricing/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-pricing" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_pricing.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/styles/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-styles" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_styles.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/styles/set-a-style/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-styles-set-a-style" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_styles_set-a-style.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/styles/use-expressions/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-styles-use-expressions" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_styles_use-expressions.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/styles/work-with-layers/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-styles-work-with-layers" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_styles_work-with-layers.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/user-interaction/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-user-interaction" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_user-interaction.js'
            ),
            
            
          },{
            path: '/ios/maps/guides/user-location/',
            getPage: () => import(
              /* webpackChunkName: "ios-maps-guides-user-location" */
              '/work/ios-sdk/_site_tmp/_ios_maps_guides_user-location.js'
            ),
            
            
          },{
            path: '/ios/navigation/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation" */
              '/work/ios-sdk/_site_tmp/_ios_navigation.js'
            ),
            
            
          },{
            path: '/ios/navigation/api-reference/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-api-reference" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_api-reference.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/advanced/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-advanced" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_advanced.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/basic/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-basic" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_basic.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/beta-query-parameters/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-beta-query-parameters" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_beta-query-parameters.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/building-extrusion/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-building-extrusion" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_building-extrusion.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/custom-banner/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-custom-banner" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_custom-banner.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/custom-destination-marker/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-custom-destination-marker" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_custom-destination-marker.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/custom-location-indicator/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-custom-location-indicator" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_custom-location-indicator.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/custom-navigation-camera/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-custom-navigation-camera" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_custom-navigation-camera.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/custom-segue/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-custom-segue" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_custom-segue.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/custom-server/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-custom-server" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_custom-server.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/custom-voice-controller/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-custom-voice-controller" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_custom-voice-controller.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/custom-waypoint/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-custom-waypoint" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_custom-waypoint.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/electronic-horizon/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-electronic-horizon" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_electronic-horizon.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/embedded-navigation/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-embedded-navigation" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_embedded-navigation.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/location-snapping/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-location-snapping" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_location-snapping.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/offline-navigation/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-offline-navigation" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_offline-navigation.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/predictive-caching/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-predictive-caching" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_predictive-caching.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/route-alerts/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-route-alerts" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_route-alerts.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/route-deserialization/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-route-deserialization" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_route-deserialization.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/route-initialization/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-route-initialization" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_route-initialization.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/route-lines-styling/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-route-lines-styling" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_route-lines-styling.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/styled-ui-elements/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-styled-ui-elements" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_styled-ui-elements.js'
            ),
            
            
          },{
            path: '/ios/navigation/examples/waypoint-arrival-screen/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-examples-waypoint-arrival-screen" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_examples_waypoint-arrival-screen.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/advanced/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-advanced" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_advanced.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/advanced/electronic-horizon/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-advanced-electronic-horizon" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_advanced_electronic-horizon.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/advanced/feedback/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-advanced-feedback" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_advanced_feedback.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/advanced/offline/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-advanced-offline" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_advanced_offline.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/advanced/searchsdk-integration/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-advanced-searchsdk-integration" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_advanced_searchsdk-integration.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/free-drive/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-free-drive" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_free-drive.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/free-drive/transition-to-turn-by-turn/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-free-drive-transition-to-turn-by-turn" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_free-drive_transition-to-turn-by-turn.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/free-drive/user-interface/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-free-drive-user-interface" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_free-drive_user-interface.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/get-started/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-get-started" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_get-started.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/get-started/install/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-get-started-install" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_get-started_install.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/get-started/location-tracking/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-get-started-location-tracking" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_get-started_location-tracking.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/get-started/storyboards/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-get-started-storyboards" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_get-started_storyboards.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/map-and-camera/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-map-and-camera" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_map-and-camera.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/map-and-camera/maps/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-map-and-camera-maps" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_map-and-camera_maps.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/map-and-camera/navigation-camera/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-map-and-camera-navigation-camera" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_map-and-camera_navigation-camera.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/migrate-to-v2/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-migrate-to-v2" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_migrate-to-v2.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/pricing/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-pricing" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_pricing.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/system-integration/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-system-integration" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_system-integration.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/system-integration/carplay/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-system-integration-carplay" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_system-integration_carplay.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/system-integration/localization-and-internationalization/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-system-integration-localization-and-internationalization" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_system-integration_localization-and-internationalization.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/system-integration/user-notifications/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-system-integration-user-notifications" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_system-integration_user-notifications.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/turn-by-turn-navigation/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-turn-by-turn-navigation" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_turn-by-turn-navigation.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/turn-by-turn-navigation/rerouting/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-turn-by-turn-navigation-rerouting" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_turn-by-turn-navigation_rerouting.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/turn-by-turn-navigation/route-alerts/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-turn-by-turn-navigation-route-alerts" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_turn-by-turn-navigation_route-alerts.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/turn-by-turn-navigation/route-generation/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-turn-by-turn-navigation-route-generation" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_turn-by-turn-navigation_route-generation.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/turn-by-turn-navigation/route-progress/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-turn-by-turn-navigation-route-progress" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_turn-by-turn-navigation_route-progress.js'
            ),
            
            
          },{
            path: '/ios/navigation/guides/turn-by-turn-navigation/user-interface/',
            getPage: () => import(
              /* webpackChunkName: "ios-navigation-guides-turn-by-turn-navigation-user-interface" */
              '/work/ios-sdk/_site_tmp/_ios_navigation_guides_turn-by-turn-navigation_user-interface.js'
            ),
            
            
          },{
            path: '/ios/search/',
            getPage: () => import(
              /* webpackChunkName: "ios-search" */
              '/work/ios-sdk/_site_tmp/_ios_search.js'
            ),
            
            
          },{
            path: '/ios/search/api-reference/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-api-reference" */
              '/work/ios-sdk/_site_tmp/_ios_search_api-reference.js'
            ),
            
            
          },{
            path: '/ios/search/examples/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-examples" */
              '/work/ios-sdk/_site_tmp/_ios_search_examples.js'
            ),
            
            
          },{
            path: '/ios/search/examples/category-based-search/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-examples-category-based-search" */
              '/work/ios-sdk/_site_tmp/_ios_search_examples_category-based-search.js'
            ),
            
            
          },{
            path: '/ios/search/examples/list-based-search/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-examples-list-based-search" */
              '/work/ios-sdk/_site_tmp/_ios_search_examples_list-based-search.js'
            ),
            
            
          },{
            path: '/ios/search/examples/mapbox-mapview-category/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-examples-mapbox-mapview-category" */
              '/work/ios-sdk/_site_tmp/_ios_search_examples_mapbox-mapview-category.js'
            ),
            
            
          },{
            path: '/ios/search/examples/mapbox-mapview/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-examples-mapbox-mapview" */
              '/work/ios-sdk/_site_tmp/_ios_search_examples_mapbox-mapview.js'
            ),
            
            
          },{
            path: '/ios/search/examples/search-ui-and-maps-sdk/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-examples-search-ui-and-maps-sdk" */
              '/work/ios-sdk/_site_tmp/_ios_search_examples_search-ui-and-maps-sdk.js'
            ),
            
            
          },{
            path: '/ios/search/examples/uitextfield-search/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-examples-uitextfield-search" */
              '/work/ios-sdk/_site_tmp/_ios_search_examples_uitextfield-search.js'
            ),
            
            
          },{
            path: '/ios/search/guides/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-guides" */
              '/work/ios-sdk/_site_tmp/_ios_search_guides.js'
            ),
            
            
          },{
            path: '/ios/search/guides/address-autofill/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-guides-address-autofill" */
              '/work/ios-sdk/_site_tmp/_ios_search_guides_address-autofill.js'
            ),
            
            
          },{
            path: '/ios/search/guides/autocomplete/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-guides-autocomplete" */
              '/work/ios-sdk/_site_tmp/_ios_search_guides_autocomplete.js'
            ),
            
            
          },{
            path: '/ios/search/guides/discover/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-guides-discover" */
              '/work/ios-sdk/_site_tmp/_ios_search_guides_discover.js'
            ),
            
            
          },{
            path: '/ios/search/guides/install/',
            getPage: () => import(
              /* webpackChunkName: "ios-search-guides-install" */
              '/work/ios-sdk/_site_tmp/_ios_search_guides_install.js'
            ),
            
            
          },{
            path: '/ios/vision/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision" */
              '/work/ios-sdk/_site_tmp/_ios_vision.js'
            ),
            
            
          },{
            path: '/ios/vision/api-reference/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision-api-reference" */
              '/work/ios-sdk/_site_tmp/_ios_vision_api-reference.js'
            ),
            
            
          },{
            path: '/ios/vision/examples/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision-examples" */
              '/work/ios-sdk/_site_tmp/_ios_vision_examples.js'
            ),
            
            
          },{
            path: '/ios/vision/examples/basic-ar-navigation/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision-examples-basic-ar-navigation" */
              '/work/ios-sdk/_site_tmp/_ios_vision_examples_basic-ar-navigation.js'
            ),
            
            
          },{
            path: '/ios/vision/examples/set-up-an-external-camera-source/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision-examples-set-up-an-external-camera-source" */
              '/work/ios-sdk/_site_tmp/_ios_vision_examples_set-up-an-external-camera-source.js'
            ),
            
            
          },{
            path: '/ios/vision/examples/speeding-alerts/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision-examples-speeding-alerts" */
              '/work/ios-sdk/_site_tmp/_ios_vision_examples_speeding-alerts.js'
            ),
            
            
          },{
            path: '/ios/vision/guides/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision-guides" */
              '/work/ios-sdk/_site_tmp/_ios_vision_guides.js'
            ),
            
            
          },{
            path: '/ios/vision/guides/ar/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision-guides-ar" */
              '/work/ios-sdk/_site_tmp/_ios_vision_guides_ar.js'
            ),
            
            
          },{
            path: '/ios/vision/guides/install-and-configure/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision-guides-install-and-configure" */
              '/work/ios-sdk/_site_tmp/_ios_vision_guides_install-and-configure.js'
            ),
            
            
          },{
            path: '/ios/vision/guides/pricing/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision-guides-pricing" */
              '/work/ios-sdk/_site_tmp/_ios_vision_guides_pricing.js'
            ),
            
            
          },{
            path: '/ios/vision/guides/safety/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision-guides-safety" */
              '/work/ios-sdk/_site_tmp/_ios_vision_guides_safety.js'
            ),
            
            
          },{
            path: '/ios/vision/guides/testing-and-development/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision-guides-testing-and-development" */
              '/work/ios-sdk/_site_tmp/_ios_vision_guides_testing-and-development.js'
            ),
            
            
          },{
            path: '/ios/vision/guides/vision-basics/',
            getPage: () => import(
              /* webpackChunkName: "ios-vision-guides-vision-basics" */
              '/work/ios-sdk/_site_tmp/_ios_vision_guides_vision-basics.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };